import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Button, Card, CardContainer, getSpacing, Picker, Text, TextAreaInput, TextInput, TextView } from '@rahtab/ui';
import { Screen } from '@rahtab/stack-navigator';
import { useState } from 'react';
import { useGetConflictReasons } from 'hooks/InventoryHooks/useGetConflictReasons';
import { RouteProp } from '@react-navigation/core';
import { RootStackType } from '../../Router';
import useStartRevision from 'hooks/InventoryHooks/useStartRevision';
import useSubmitRevision from 'hooks/InventoryHooks/useSubmitRevision';
import { useLoad } from 'hooks/InventoryHooks/useLoad';
import { withNumbers, withSeparator } from '@rahtab/system/lib/tools/string';
import { useEffect } from 'react';

const SubmitNewFix: React.VFC<SubmitNewFixProps> = ({ route }) => {
  const { assignFinalCode } = route.params;
  const [remainingQuantity, setRemainingQuantity] = useState('0');
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('');
  const [comment, setComment] = useState('');
  const { data, loading, called } = useGetConflictReasons();
  const { data: loadInventory, loading: loadInventoryLoading, called: loadInventoryCalled } = useLoad({
    assignFinalCode,
  });
  const {
    startRevision,
    loading: startRevisionLoading,
    called: startRevisionCalled,
    data: startRevisionResult,
  } = useStartRevision(assignFinalCode!);

  const { submitRevision, loading: isSubmitting } = useSubmitRevision({
    assignFinalCode,
    autoReStock: '0',
    comment,
    compileDC: startRevisionResult?.compileDC!,
    reasonCode: reason,
    remainingAmount: amount,
    wfInstanceCode: startRevisionResult?.wfInstanceCode!,
    stateCode: startRevisionResult?.stateCode!,
  });
  useEffect(() => {
    if (!startRevisionCalled) startRevision();
    if (!startRevisionLoading && !!startRevisionResult) {
      setRemainingQuantity(startRevisionResult.remainingValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startRevisionCalled, startRevisionLoading]);

  const conflictAmount = Math.abs(parseFloat(amount) - parseFloat(remainingQuantity));
  const conflictPercent = Math.floor((conflictAmount / parseFloat(remainingQuantity)) * 100);
  const isLoading = (!called && loading) || (!loadInventoryCalled && loadInventoryLoading);
  const isSubmitBtnDisabled = !amount || !reason;
  return (
    <Screen
      title="ثبت اصلاح موجودی"
      loading={isLoading || startRevisionLoading}
      transparentLoading={isSubmitting}
      data={{ ...loadInventory, ...startRevisionResult }}
      renderMain={() => {
        return (
          <Card style={styles.card}>
            <CardContainer>
              <Text style={{ textAlign: 'justify' }}>
                اطلاعات اصلاحیه موجودی بار دریافتی را همراه با ذکر دلیل و ارائه توضیحات ثبت نمایید.
              </Text>
              <TextInput
                onChangeText={withNumbers(setAmount)}
                value={amount}
                placeholder="مقدار موجودی واقعی خود را وارد نمایید."
                label="مقدار موجودی"
                keyboardType="numeric"
              />
              <View style={styles.textViewContainer}>
                <TextView
                  style={styles.amountTextView}
                  valueColor="secondary"
                  title="مقدار مغایرت موجودی"
                  value={`${
                    isNaN(conflictAmount) ? '0' : withSeparator(conflictAmount)
                  } ${loadInventory?.measureName!}`}
                />
                <TextView
                  textContainerStyle={styles.percentTextContainerStyle}
                  style={styles.percentTextView}
                  value={`٪${isNaN(conflictPercent) ? 0 : conflictPercent}`}
                  valueColor="secondary"
                />
              </View>
              <Picker placeholder="دلیل مغایرت موجودی را مشخص نمایید." onSelectValue={setReason} selectedValue={reason}>
                {data?.map((item, index) => {
                  return <Picker.Item key={`reason-${index}`} label={item.reasonLabel} value={item.reasonCode} />;
                })}
              </Picker>
              <TextAreaInput
                placeholder="توضیحات مغایرت موجودی را وارد نمایید."
                label="توضیحات"
                onChangeText={setComment}
                value={comment}
              />
              <Button
                text="ثبت اصلاحیه موجودی"
                color="primary"
                onPress={submitRevision}
                disabled={isSubmitBtnDisabled}
              />
            </CardContainer>
          </Card>
        );
      }}
    />
  );
};

export default SubmitNewFix;

const styles = StyleSheet.create({
  card: {
    margin: getSpacing(),
  },
  textViewContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  percentTextView: {
    // flex: 0.5,
    width: 50,
  },
  percentTextContainerStyle: {
    justifyContent: 'center',
  },
  amountTextView: {
    flex: 6,
    marginRight: getSpacing(),
  },
});

interface SubmitNewFixProps {
  route: RouteProp<RootStackType, 'SubmitNewFix'>;
}
